import type { IPackageSubscription, IUserResponse, IUserResponseV1, UserRole } from "@/types"

export class User {
  public id?: number
  public name?: string
  public email?: string
  public affiliateId?: string
  public roles: UserRole[] = []
  public packageSubscription?: IPackageSubscription
  public emailConfirmed?: boolean = false

  constructor(user: Partial<User>) {
    this.id = user.id
    this.name = user.name
    this.email = user.email
    this.affiliateId = user.affiliateId
    this.roles = user.roles ?? []
    this.packageSubscription = user.packageSubscription
    this.emailConfirmed = user.emailConfirmed ?? false
  }

  public static fromResponseV1(response?: IUserResponseV1) {
    return new User({
      name: response?.name,
      email: response?.email,
      affiliateId: response?.affiliateId,
      roles: response?.roles ?? [],
      packageSubscription: {
        packageSubscriptionId: response?.packageSubscriptionDTO?.packageSubscriptionID,
        wooSubscriptionId: response?.packageSubscriptionDTO?.wooSubscriptionID,
        tierName: response?.packageSubscriptionDTO?.packageTierName,
        status: response?.packageSubscriptionDTO?.packageSubscriptionStatus,
        billingPeriod: response?.packageSubscriptionDTO?.billingPeriod,
        eventsUsed: response?.packageSubscriptionDTO?.eventsUsed ?? 0,
        maxEvents: response?.packageSubscriptionDTO?.maxEvents ?? 0,
        expiryDate: response?.packageSubscriptionDTO?.expiryDate,
        token: response?.packageSubscriptionDTO?.token,
        oneTimePayment: response?.packageSubscriptionDTO?.oneTimePayment ?? false,
      },
      emailConfirmed: response?.emailConfirmed ?? false,
    })
  }

  public static fromResponse(response?: IUserResponse) {
    if (!response) {
      throw new Error("Unable to convert user response to User model")
    }

    return new User({
      id: response.UserID,
      name: response.Name,
      email: response.Email,
      affiliateId: response.AffiliateID,
      roles: response.Roles,
      emailConfirmed: response.EmailConfirmed ?? false,
    })
  }
}
